import { useCallback, useState } from "react";

const useHttpNoAuth = (requestConfig, applyData) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);


    try {
      // fetch sets its own multipart content-type — including the boundary.
      const headers = requestConfig.isFileUpload
        ? { ...requestConfig.headers }
        : {
            "Content-type": "application/json; charset=utf-8",
            ...requestConfig.headers,
          };

      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: headers,
        body: requestConfig.body
          ? requestConfig.isFileUpload === true
            ? requestConfig.body
            : JSON.stringify(requestConfig.body)
          : null,
      });

      if (!response.ok) {

        const responseData = await response.json();
        setError(responseData.detail || "Request failed.");
        throw new Error(responseData.detail || "Request failed.");
      }

      let data = null;

      if(response.status !== 204){
        data = await response.json();
      } 

      applyData(data);
    } catch (err) {
      setError(err.message || "Something went wrong.");
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttpNoAuth;
